import { render, staticRenderFns } from "./Template_3.vue?vue&type=template&id=b432b846&scoped=true"
import script from "./Template_3.vue?vue&type=script&lang=js"
export * from "./Template_3.vue?vue&type=script&lang=js"
import style0 from "./Template_3.vue?vue&type=style&index=0&id=b432b846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b432b846",
  null
  
)

export default component.exports